import { JSX, ReactNode } from 'react'

import { Box, Flex, HStack, BoxProps, FlexProps } from '@chakra-ui/react'
// eslint-disable-next-line no-duplicate-imports
import { Icon, IconButton, Input, InputGroup, Kbd } from '@chakra-ui/react'

import { LuFilter } from 'react-icons/lu'
import { RxMagnifyingGlass, RxCross2 } from 'react-icons/rx'

import * as detective from '@/lib/detective.js'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Layout from '@/components/ui/layout.tsx'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Search
(
	props: {
		value       : string
		placeholder?: string

		change?(v: string): void
		enter?(): void

	},

)
:	JSX.Element
{
	let on_change = (e: React.ChangeEvent<HTMLInputElement>): void =>
	{
		props.change?.(e.target.value)

	}

	let on_enter = (): void =>
	{
		props.enter?.()

	}

	let on_clear = (): void =>
	{
		props.change?.('')

	}

	let on_enter_key_down = (e: React.KeyboardEvent<HTMLInputElement>): void =>
	{
		if (e.key !== 'Enter')
		{
			return

		}

		on_enter()

	}


	let intor = [<Kbd key="enter" cursor="pointer" onClick={on_enter}>Enter</Kbd>]

	if (detective.is_required_string(props.value) )
	{
		intor.unshift(
			<Icon key="clear" cursor="pointer" boxSize="4" mr="2" color="border.emphasized" onClick={on_clear}><RxCross2 /></Icon>,

		)

	}

	return (
		<InputGroup
			w="xl"
			borderBottom="sm"
			borderColor="border.emphasized"
			startElement={<Icon boxSize="6"><RxMagnifyingGlass /></Icon>}
			endElement={intor}
		>
			<Input
				size="xl"
				border="none"
				variant="flushed"
				value={props.value}
				placeholder={props.placeholder ?? ''}
				onChange={on_change}
				onKeyDown={on_enter_key_down}
			/>
		</InputGroup>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Filter
(
	props: {
		children?: ReactNode

		open?(): void

	},

)
:	JSX.Element
{
	let on_open = (): void =>
	{
		props.open?.()

	}

	return (
		<HStack gap="4" flex="auto" justify="flex-end">
			<IconButton variant="outline" bg="white" color="fg" rounded="md" onClick={on_open}>
				<LuFilter />
			</IconButton>

			{props.children}
		</HStack>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Toolbar
(props: FlexProps): JSX.Element
{
	if (detective.is_empty(props.children) )
	{
		return (<></>)

	}

	return (
		<Flex pl="4" pr="4" gap="4" position="relative" {...props} />

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Section
(props: BoxProps): JSX.Element
{
	if (detective.is_empty(props.children) )
	{
		return (<></>)

	}

	return (
		<Box as="section" pl="4" pr="4" flex="auto" position="relative" {...props} />

	)

}

export const scroll_styles: BoxProps = {
	flex          : 'auto',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	overflowY     : 'auto',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	scrollbarWidth: 'thin',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	scrollbarColor: '{colors.gray.emphasized} transparent',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	scrollBehavior: 'smooth',

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Scroll
(props: BoxProps): JSX.Element
{
	return (
		<Section pr="2" {...scroll_styles} {...props} />

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root
(
	props: BoxProps
			& {
				deep?: number

			},

)
:	JSX.Element
{
	let deep = props.deep ?? 0

	if (detective.is_empty(props.children) )
	{
		return (<></>)

	}

	return (
		<Layout.Alive
			as="main"
			pt="4"
			pb="4"
			gap="4"
			position="relative"
			flexDirection="column"
			h="calc({sizes.vh} - {sizes.12})"
			display="flex"
			deep={deep}
			{...props}

		/>

	)

}
